export const applicationsContext = require.context(".", true, /\_controller.js$/)
